import { render, staticRenderFns } from "./statusBarReason.vue?vue&type=template&id=16d6bc95&scoped=true"
import script from "./statusBarReason.vue?vue&type=script&lang=js"
export * from "./statusBarReason.vue?vue&type=script&lang=js"
import style0 from "./statusBarReason.vue?vue&type=style&index=0&id=16d6bc95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6bc95",
  null
  
)

export default component.exports